//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Die/Die.DiePlaneBuilder.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../Die/Die.DieDirectionBuilder.js";
import "../Die/Die.DieLocationBuilder.js";
import "../no/Section.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[1,"BaseOffset",0,"Expression",0],[1,"BaseOrientation",0,"Die.DiePlaneBuilder",0],[1,"BeltAttributes",0,"Die.DieAttributesBuilder",0],[1,"BeltFaceThickness",0,"Expression",0],[1,"CamDirection",0,"Die.DieDirectionBuilder",0],[0,"DistanceTolerance",1,0],[1,"End",0,"Die.DieLocationBuilder",0],[1,"InsideWallProfile",0,"Section",0],[0,"JogWall",1,0],[1,"MainProfile",0,"Section",0],[0,"MainProfileType",1,0],[1,"Offset",0,"Expression",0],[1,"ProfileOffset",0,"Expression",0],[1,"Relief",0,"Expression",0],[1,"ReliefOffset",0,"Expression",0],[1,"Start",0,"Die.DieLocationBuilder",0],[0,"SwitchTrimSide",1,0],[1,"Target",0,"SelectBody",0],[1,"TopOffset",0,"Expression",0],[1,"TrimOffset",0,"Expression",0],[1,"TrimSheet",0,"SelectBody",0],[1,"TrimSheetFace",0,"ScCollector",0],[1,"TrimSheetOffset",0,"Expression",0],[0,"TrimSheetType",1,0],[0,"Type",1,0],[1,"WallOffset",0,"Expression",0],[1,"WallThickness",0,"Expression",0]],[],[]];
SPLM.Die.MachineReliefBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.MachineReliefBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.MachineReliefBuilder.Types = Object.freeze({
    "Cam" : "Cam", "Relief" : "Relief", "Thicken" : "Thicken"});

SPLM.Die.MachineReliefBuilder.MainProfileTypes = Object.freeze({
    "Exterior" : "Exterior", "Interior" : "Interior"});

SPLM.Die.MachineReliefBuilder.TrimSheetTypes = Object.freeze({
    "Sheet" : "Sheet", "Face" : "Face"});

export default SPLM;